<template>
  <div class="mx-auto  my-[20px] text-center">

    <div class="flex justify-center mb-4">
      <img
        :alt="data.distributorName"
        class="mb-2"
        :src="data.distributorLogo"
        v-if="data.distributorLogo"
        style="height: 50px; width: 160px"
      >
      <div
        v-else
        class="font-bold text-3xl"
      >
        {{ data.distributorName }}
      </div>
    </div>
    <div class="flex justify-between text-gray-500">
      <div>
        {{ dateReceived }}
      </div>
      <div>
        {{ data.paymentMethod?.description }}
      </div>
    </div>
    <hr class="mt-2">
    <div class="flex justify-between font-bold mt-2">
      <h1>Description</h1>
      <h1>Amount</h1>
    </div>
    <div
      class="flex justify-between text-gray-500"
      v-for="invoice in invoices"
      :key="invoice.id"
    >
      <p>Invoice #{{ invoice.number }}</p>
      <p>{{ currency }}{{ formattedCost(invoice.amount) }}</p>
    </div>
    <div class="flex justify-between text-gray-500" v-if="data.overPayment">
      <p>Loaded to customer wallet</p>
      <p>{{ currency }}{{ formattedCost(data.overPayment) }}</p>
    </div>
    <div class="flex justify-between mt-2">
      <h1>Total</h1>
      <h1 class="font-bold">{{ currency }}{{ formattedCost(data.amount) }}</h1>
    </div>
    <hr class="my-2">
    <div class="text-gray-500 text-sm">
      <p>Thank you for the payment</p>
    </div>

  </div>
</template>

<script setup>
import { computed } from 'vue';
import { format } from 'date-fns';

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});
const dateReceived = computed(() => {
  if (!props.data.dateReceived) return null;
  return format(new Date(props.data.dateReceived), 'd MMM yyyy, HH:mm');
});

const currency = computed(() => props.data?.currency);
const invoices = computed(() => (props.data?.invoices ?? [])
  .filter((i) => parseFloat(i?.amount ?? 0) > 0));
const formattedCost = (cost) => new Intl.NumberFormat().format(cost);

</script>
